export default function Footer() {
  return (
    <footer
      className="py-10 px-6"
      style={{ background: "#0d1525", borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div
            className="w-6 h-6 flex items-center justify-center rounded"
            style={{ background: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)" }}
          >
            <i className="ri-settings-3-line text-xs text-white" />
          </div>
          <span className="text-xs font-bold tracking-widest" style={{ color: "rgba(255,255,255,0.4)", letterSpacing: "0.15em" }}>
            CHIRUNNEXA
          </span>
        </div>

        <p className="text-xs text-center" style={{ color: "rgba(255,255,255,0.25)" }}>
          &copy; {new Date().getFullYear()} Chirunnexa Global Supply Chain Platform. All rights reserved.
        </p>

        <a
          href="mailto:chirunnexa@gmail.com"
          className="text-xs transition-colors duration-200 cursor-pointer"
          style={{ color: "rgba(255,255,255,0.25)" }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#F59E0B")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.25)")}
        >
          chirunnexa@gmail.com
        </a>
      </div>
    </footer>
  );
}
